<template>
    <div class="cta-caja cta-caja--lila" @click="clicking">
      <product-added-dialog-ok :showProductAddedConfirmation="showProductAddedConfirmation"  />
      <div class="cta-caja__cover">
        <img
          class="cta-caja__cover-desk"
          src="https://images.hellobb.net/moises-sleepee-desktop.png"
          alt=""
        />
        <img
          class="cta-caja__cover-mobile"
          src="https://images.hellobb.net/moises-sleepee-responsive.png"
          alt=""
        />
      </div>
      <div class="cta-caja__content">
        <h4 class="cta-caja__title">Moisés Sleepee, las siestas más cómodas</h4>
        <div class="cta-caja__description">
          <p>Tu peque dormirá cómodamente allá donde lo lleves.</p>
        </div>
        <div class="cta-caja__actions">
          <loading-button v-if="loading" :class="'button-loading--sm'" />
          <button
            v-else
            class="button button--accent button--sm button--ico"
            @click.stop="addProduct('Constructor - Banner Horitzontal')"
            :disabled="added"
          >
            {{ buttonText }}
          </button>
        </div>
      </div>
      <modal-dialog
          :show="showProductAddedDialog"
          @close="showProductAddedDialog = false"
          target-class="modal__card--mini"
      >
        <product-added-to-list/>
      </modal-dialog>
    </div>
  </template>
  
  <script>
  import Product from "./Mixins/Product";
  import LoadingButton from "../../../components/LoadingButton";
  import ModalDialog from "../../../components/ui/ModalDialog";
  import ProductAddedToList from "../../../components/ProductAddedToList";
  import ProductAddedDialogOk from "../../../components/ProductAddedDialogOk";
  
  export default {
    name: "CtaMoisesSleepe",
    mixins: [Product],
    components: {
      LoadingButton,
      ModalDialog,
      ProductAddedToList,
      ProductAddedDialogOk,
    },
    computed: {
      buttonText() {
        return this.added ? "Añadido" : "Añadir a mi lista";
      },
    },
    data() {
      return {
        showProductAddedConfirmation: false,
      };
    },
    created() {
      this.product = {
        id: 42018,
        "brand-slug": "tommee-tippee",
        name: "Moisés Sleepee",
        retailerName: "HelloBB",
        productRetailers: [{"name": "HelloBB"}]
      };
    },
    methods: {
      clicking()
      {
        mixpanel.track("Click element constructor", {
          "Name": "Moisés Sleepee",
          "Section": "Lo mejor para portear",
          "Section number": 2,
          "Type": "Banner - Horizontal",
          "Content": "Ecommerce"
        });
        this.browseProduct();
      }
    }
  };
  </script>